import React from 'react'

export default function SkeletonSection() {
    return (
        <div className="container-custom section-padding">
            <div className="animate-pulse">
                <div className="h-8 bg-black-200 rounded w-1/3 mb-6"></div>
                <div className="space-y-4">
                    <div className="h-4 bg-black-200 rounded w-full"></div>
                    <div className="h-4 bg-black-200 rounded w-5/6"></div>
                    <div className="h-4 bg-black-200 rounded w-4/6"></div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
                    {[...Array(3)].map((_, i) => (
                        <div key={i} className="space-y-3">
                            <div className="h-48 bg-black-200 rounded-lg"></div>
                            <div className="h-4 bg-black-200 rounded w-3/4"></div>
                            <div className="h-4 bg-black-200 rounded w-1/2"></div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}